import { requestToken, requestTokenImage } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/payment-account`;

/** Public URL for a stored QR image filename. */
export const paymentQrUrl = (filename) =>
  filename ? `${API_ROUTE}/qr/${filename}` : null;

class PaymentAccountServices {
  /** Super Admin - full list including deactivated accounts. */
  async getPaymentAccountList() {
    try {
      const action = API_ROUTE + `/list`;
      const response = await requestToken.get(action);
      return response;
    } catch (error) {
      console.error("Error in getPaymentAccountList:", error);
      throw error;
    }
  }

  /** Any logged-in user - only active accounts, used by the deposit screen. */
  async getActivePaymentAccounts(method) {
    try {
      const action = API_ROUTE + `/active`;
      const response = await requestToken.get(action, method ? { method } : {});
      return response;
    } catch (error) {
      console.error("Error in getActivePaymentAccounts:", error);
      throw error;
    }
  }

  /** payload must be FormData - QR accounts carry a file. */
  async createPaymentAccount(payload) {
    try {
      const action = API_ROUTE + `/create`;
      const response = await requestTokenImage.post(action, payload);
      return response;
    } catch (error) {
      console.error("Error in createPaymentAccount:", error);
      throw error;
    }
  }

  /** payload must be FormData. QR image is replaced only if a file is sent. */
  async updatePaymentAccount(payload) {
    try {
      const action = API_ROUTE + `/update`;
      const response = await requestTokenImage.post(action, payload);
      return response;
    } catch (error) {
      console.error("Error in updatePaymentAccount:", error);
      throw error;
    }
  }

  async togglePaymentAccountStatus(id, is_active) {
    try {
      const action = API_ROUTE + `/toggle-status`;
      const response = await requestToken.post(action, { id, is_active });
      return response;
    } catch (error) {
      console.error("Error in togglePaymentAccountStatus:", error);
      throw error;
    }
  }

  async deletePaymentAccount(id) {
    try {
      const action = API_ROUTE + `/delete`;
      const response = await requestToken.post(action, { id });
      return response;
    } catch (error) {
      console.error("Error in deletePaymentAccount:", error);
      throw error;
    }
  }
}

export default PaymentAccountServices;
